// extracted by mini-css-extract-plugin
export default {"NoMatch":"NoMatchView_NoMatch__8Cpu+"};